module.exports = __webpack_public_path__ + "img/bybit_2.c5120f14.png";